module.exports = __webpack_public_path__ + "img/syimg1.c587c596.png";